import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_pinIdAdapter27yg3a7qzsov7 as get_pinIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeletePinInputmel7ixrs09hz as DeletePinInput } from '../DeletePinInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePinInput_InputAdapterClass;
function DeletePinInput_InputAdapter() {
  if (DeletePinInput_InputAdapterClass === VOID) {
    class $ {
      s3x(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      s6s(writer, customScalarAdapters, value) {
        writer.k4a('partyId');
        get_partyIdAdapter().t3x(writer, customScalarAdapters, value.i6p_1);
        writer.k4a('pinId');
        get_pinIdAdapter().t3x(writer, customScalarAdapters, value.j6p_1);
      }
      t3x(writer, customScalarAdapters, value) {
        return this.s6s(writer, customScalarAdapters, value instanceof DeletePinInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DeletePinInput_InputAdapter', VOID, VOID, [Adapter()]);
    DeletePinInput_InputAdapterClass = $;
  }
  return DeletePinInput_InputAdapterClass;
}
var DeletePinInput_InputAdapter_instance;
function DeletePinInput_InputAdapter_getInstance() {
  return DeletePinInput_InputAdapter_instance;
}
//region block: init
DeletePinInput_InputAdapter_instance = new (DeletePinInput_InputAdapter())();
//endregion
//region block: exports
export {
  DeletePinInput_InputAdapter_instance as DeletePinInput_InputAdapter_instancef1q64acype4n,
};
//endregion

//# sourceMappingURL=DeletePinInput_InputAdapter.mjs.map
